import React from 'react';

import styled from '@emotion/styled';

import {
  LookupPriceInitialValues,
  LookupPriceSchema,
} from '../../../../models/dashboard/driver-lookup/lookup-price';
import { useAppSelector } from '../../../../redux/store';
import { formatNairaWithoutDecimal } from '../../../../utils/utils';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import { FormComponent } from '../../../FormCom/FormComponent';
import NumberOnlyInputField from '../../../FormCom/NumberOnlyInputField';

interface TriggerRegularPricePaymentFormProps {
  handleOnSubmit: (values: any, actions: any) => void;
  handleAmountFieldChange: (amount: string) => void;
  loading: boolean;
  amount: number;
  price: number;
}

const TriggerRegularPricePaymentForm: React.FC<
  TriggerRegularPricePaymentFormProps
> = ({ handleOnSubmit, handleAmountFieldChange, loading, amount }) => {
  const { lookupConfig } = useAppSelector((state) => state.lookupConfigData);

  return (
    <>
      <TextArea>
        <HeaderText>
          <BoldText>Single Look-up</BoldText>
          <BoldText>
            {formatNairaWithoutDecimal(lookupConfig?.unitPrice ?? 0)}
          </BoldText>
        </HeaderText>
        <LightText>
          Indicate their preferred number. Look-up is added instantly
        </LightText>
      </TextArea>

      <FormComponent
        initialValues={LookupPriceInitialValues}
        schema={LookupPriceSchema}
        onSubmit={handleOnSubmit}
      >
        <NumberOnlyInputField
          label='Number of Look-up'
          name='amount'
          id='amount'
          type='text'
          placeholder='0'
          onValueChange={(value) => handleAmountFieldChange(value)}
        />

        <FormSubmitButton loading={loading}>
          {`Pay ${formatNairaWithoutDecimal(amount)} via Paystack`}
        </FormSubmitButton>
      </FormComponent>
    </>
  );
};

export default TriggerRegularPricePaymentForm;

const TextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-right: auto;
  padding: 16px;
  border-radius: 6px;
  background-color: rgba(59, 124, 244, 0.05);
  width: 100%;
`;

const HeaderText = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const BoldText = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;

const LightText = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  color: ${({ theme }) => theme.palette.neutralGray};
`;
